
if (history.scrollRestoration) {
    history.scrollRestoration = "manual";
    console.log('🚀🚀🚀 disabled history.scrollRestoration')
}

function page_load(collection_grid) {
    var back_col_html = localStorage.getItem('back_col_html');
    var back_col_url = localStorage.getItem('back_col_url');
    var back_col_next_url = localStorage.getItem('back_col_next_url');

    if (back_col_url == window.location.href) {
        collection_grid.innerHTML = back_col_html;
        collection_grid.setAttribute('data-next-url', back_col_next_url);
        if (collection_grid.getAttribute('data-next-url') == '') {
            const load_button_container = document.querySelector(".custom-filter-load-more");
            if (load_button_container) {
                load_button_container.style.display = 'none'
            }
        }
    }

    document.addEventListener('click', function(event) {

        const product_card = event.target.closest('.product-card');
        if (product_card) {
            localStorage.setItem('back_col_html', collection_grid.innerHTML);
            localStorage.setItem('back_col_url', window.location.href);
            localStorage.setItem('back_col_next_url', collection_grid.getAttribute('data-next-url'));
        }
    });
    // window.onunload = function () {
    //     localStorage.setItem('back_col_html', collection_grid.innerHTML);
    //     localStorage.setItem('back_col_url', window.location.href);
    //     localStorage.setItem('back_col_next_url', collection_grid.getAttribute('data-next-url'));
    // };
}

page_load(document.querySelector('.collection-grid'));


//window.history.scrollRestoration = "manual";
const STORAGE_KEY_ORIG = "collection-original-scroll-y";
const HISTORY_LOCATION = "history-last-scrolled-collection";
const cardLinks = document.querySelectorAll(
    ".collection-grid .product-card a"
);

document.addEventListener('click', function(event) {

    const product_card = event.target.closest('.product-card');
    let scrollOffset = window.scrollY || window.pageYOffSet;
    if (product_card) {
        sessionStorage.setItem(STORAGE_KEY_ORIG, scrollOffset );
        sessionStorage.setItem(HISTORY_LOCATION, window.location.href);
    }
});

function collectionHistoryBack() {
    console.log( '🚀🚀🚀 history location: ', window.location.href, ' | storage_key_orig: ', sessionStorage.getItem( STORAGE_KEY_ORIG ) );
    if (sessionStorage.getItem(HISTORY_LOCATION) == window.location.href) {
        const scroll_curr_y = sessionStorage.getItem(STORAGE_KEY_ORIG) || 0;
        if (sessionStorage.getItem(STORAGE_KEY_ORIG)) {
            window.scrollTo({
                top: scroll_curr_y,
                left: 0,
                behavior: "instant",
            });
        }
    }
}
window.addEventListener("load", collectionHistoryBack);

function chainEventListeners() {
    const removeItems = () => {
        sessionStorage.removeItem(STORAGE_KEY_ORIG);
        sessionStorage.removeItem(HISTORY_LOCATION);
    };

    window.addEventListener("mousewheel", removeItems);
    window.addEventListener("touchstart", removeItems);
}

chainEventListeners();



document.addEventListener('DOMContentLoaded', function () {

    // Load more products

    const load_btn_container = document.querySelector(".custom-filter-load-more");
    

    let products_on_page = document.querySelector('.collection-grid');

    let url = products_on_page.getAttribute('data-next-url');

    const spinner = document.querySelector('.load-more-spinner');

    if (load_btn_container) {
        if (url === '') {
            load_btn_container.style.display = 'none';
        }

        // Define a function to handle the intersection of the load button
        function handleLoadButtonIntersection(entries, observer) {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    // Load the next page of results
                    loadNextPage();
                }
            });
        }

        // Create an intersection observer that calls the handleLoadButtonIntersection function
        // const observer = new IntersectionObserver(handleLoadButtonIntersection);

        // Observe the load button
        // observer.observe(load_btn_container);


        const load_button = document.querySelector('.load-more-btn');

        if ( load_button ) {
            load_button.addEventListener( 'click', loadNextPage );
        }

        // Function to load the next page of results
        function loadNextPage() {
            load_btn_container.classList.add('loading');
            // spinner.classList.add("show");

            fetch(url)
                .then(function (response) {
                    if (response.ok) {
                        return response.text();
                    } else {
                        throw new Error('Network response was not ok.');
                    }
                })
                .then(function (data) {
                    const html = document.createElement('div');
                    html.innerHTML = data;

                    // let links = html.querySelector('.pagination-links').innerHTML;

                    // document.querySelector('.pagination-links').innerHTML = links;

                    let new_grid = html.querySelector('.collection-grid');
                    url = new_grid.getAttribute('data-next-url');
                    document.querySelector('.collection-grid').setAttribute('data-next-url',url)
                    if (url === '') {
                        load_btn_container.style.display = 'none';
                    }
                    let new_products = new_grid.querySelectorAll(".product-card, #collection-advert, #collection-advert-2");

                    new_products.forEach(new_prod => {
                        products_on_page.append(new_prod);
                    });
                    // spinner.classList.remove("show");

                    document.querySelector('.collection-status').innerHTML = html.querySelector('.collection-status').innerHTML;

                    load_btn_container.classList.remove('loading');
                })
                .catch(function (error) {
                    window.log(error);
                });
        }
    }

    const rangeInput = document.querySelectorAll(".range-input input");
    if (rangeInput) {
        const priceInput = document.querySelectorAll(".price-input-show");
        const range = document.querySelector(".slider .progress");
        const minFilterInput = document.querySelector('.min-price-filter');
        const maxFilterInput = document.querySelector('.max-price-filter');
        let priceGap = 1;

        if (maxFilterInput) {
            if (maxFilterInput.value != "") {
                range.style.left = ((minFilterInput.value / rangeInput[0].max) * 100) + "%";
                range.style.right = 100 - (maxFilterInput.value / rangeInput[1].max) * 100 + "%";
                rangeInput[0].value = minFilterInput.value;
                rangeInput[1].value = maxFilterInput.value;
                priceInput[0].innerHTML = minFilterInput.value;
                priceInput[1].innerHTML = maxFilterInput.value;
            }

            priceInput.forEach(input => {
                input.addEventListener("input", e => {
                    let minPrice = parseInt(priceInput[0].innerHTML);
                    let maxPrice = parseInt(priceInput[1].innerHTML);

                    if ((maxPrice - minPrice >= priceGap) && maxPrice <= rangeInput[1].max) {
                        if (e.target.className === "input-min") {
                            rangeInput[0].value = minPrice;
                            rangeInput[0].setAttribute("data-term", minPrice);
                            range.style.left = ((minPrice / rangeInput[0].max) * 100) + "%";
                        } else {
                            rangeInput[1].value = maxPrice;
                            maxFilterInput.value = maxVal;
                            range.style.right = 100 - (maxPrice / rangeInput[1].max) * 100 + "%";
                        }
                    }
                });
            });

            rangeInput.forEach(input => {
                input.addEventListener("input", e => {
                    let minVal = parseInt(rangeInput[0].value),
                        maxVal = parseInt(rangeInput[1].value);

                    if ((maxVal - minVal) < priceGap) {
                        if (e.target.className === "range-min") {
                            rangeInput[0].value = maxVal - priceGap
                        } else {
                            rangeInput[1].value = minVal + priceGap;
                        }
                    } else {
                        priceInput[0].innerHTML = minVal;
                        priceInput[1].innerHTML = maxVal;
                        range.style.left = ((minVal / rangeInput[0].max) * 100) + "%";
                        range.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + "%";
                        minFilterInput.value = minVal;
                        maxFilterInput.value = maxVal;
                    }
                });
            });
        }
    }


    let custom_filters = document.querySelectorAll(".custom-filter")

    custom_filters.forEach((el) => {

        let control = el.querySelector(".filter-heading")
        let body = el.querySelector(".filter-body")

        if (control && body) {

            control.addEventListener('click', () => {

                if (el.classList.contains("open")) {
                    el.classList.remove("open")
                } else {
                    el.classList.add("open")
                }

            })
        }
    })

    let mobile_control = document.querySelector(".mobile-filter-heading")
    let filter_body = document.querySelector(".custom-filter-wrapper")

    if (mobile_control && filter_body) {
        mobile_control.addEventListener('click', () => {
            console.log("CLICK")
            // rotate svg
            if (mobile_control.classList.contains("open")) {
                mobile_control.classList.remove("open")
            } else {
                mobile_control.classList.add("open")
            }

            // open filters
            if (filter_body.classList.contains("open")) {
                filter_body.classList.remove("open")
            } else {
                filter_body.classList.add("open")
            }
        })
    }

    // Hide reset filters when no filters active
   // const reset_filters = document.querySelector('.reset-filter-wrapper');
    const selected_filters_html = document.querySelectorAll('.selected-filter-wrapper *');

    /*
    if (selected_filters_html.length > 0) {
        reset_filters.style.display = 'block';
    }
    */

    selected_filters_html.forEach(selected => {
        selected.addEventListener('click', () => {
            collection_grid.classList.add("loading")
        })
    })

    // Submit form on input change

    const filter_inputs = document.querySelectorAll('.filter-container-wrapper select, .filter-container-wrapper input');
    const filter_form = document.querySelector('.filter-container');
    //const reset_filter = document.querySelector('#reset-filters');
    const collection_grid = document.querySelector('.collection-grid');

    filter_inputs.forEach(input => {
        input.addEventListener('change', () => {
            collection_grid.classList.add("loading")
            filter_form.submit()
        })
    })

    /*
    reset_filter.addEventListener('click', () => {
        collection_grid.classList.add("loading")
    })
    */


})